import { SharedXYChartTooltip } from './SharedXYChartTooltip/SharedXYChartTooltip.js';
import { XYChartTooltipContent } from './XYChartTooltipContent.js';
import {
  useSelector,
  useTooltipSnapshot,
} from '../../../core/components/overlay-tooltip/selectors.js';
import { isTooltipDataEmpty } from '../../../core/components/overlay-tooltip/utils.js';
import type { XYChartTooltipMetadata } from '../../types/state.js';

export const XYChartOverlayTooltip = () => {
  useSelector(
    ({ pinned, relativeX, relativeY }) => `${pinned}-${relativeX}-${relativeY}`,
  );
  const { data } = useTooltipSnapshot();

  if (isTooltipDataEmpty(data)) {
    return null;
  }

  const { preferred, datapoints } = data.metadata as XYChartTooltipMetadata;

  if (datapoints.length > 1) {
    return (
      <SharedXYChartTooltip preferred={preferred} datapoints={datapoints} />
    );
  }

  return <XYChartTooltipContent content={preferred} />;
};

XYChartOverlayTooltip['displayName'] = 'XYChartOverlayTooltip';
